import React from "react";
import PageHero from "../components/dental/PageHero";
import SectionTitle from "../components/dental/SectionTitle";
import Button from "../components/dental/Button";
import { Check } from "lucide-react";
import { doctorBio } from "../data/site";

const MeetDoctor = () => (
  <>
    <PageHero
      subtitle="Dr.K"
      title="Meet The Doctor"
      breadcrumb="Meet The Doctor"
      image={doctorBio.image}
    />

    <section className="bg-[#FBF8F1] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-28 h-28 border border-[#B79A68]/50 z-0" />
            <img
              src={doctorBio.image}
              alt={doctorBio.name}
              className="relative w-full h-[520px] object-cover z-10"
            />
            <div className="absolute -bottom-4 -right-4 w-28 h-28 border border-[#B79A68]/50 z-0" />
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="font-script text-4xl md:text-5xl gold-gradient-text leading-none p-2">
            {doctorBio.name}
          </p>
          
          <p className="text-[#7D6A42] uppercase tracking-[0.3em] text-[11px] mt-3 font-cinzel">
            {doctorBio.title}
          </p>
          <div className="w-16 h-px bg-[#B79A68] my-6" />
          <p className="text-[#4E5750] text-lg leading-relaxed mb-5">{doctorBio.intro}</p>
          {doctorBio.paragraphs.map((p, i) => (
            <p key={i} className="text-[#4E5750]/85 leading-relaxed mb-4">{p}</p>
          ))}
          <div className="mt-8">
            <h3 className="font-cinzel text-sm gold-gradient-text uppercase tracking-[0.2em] mb-4">
              Credentials & Affiliations
            </h3>
            <ul className="space-y-3">
              {doctorBio.credentials.map((c) => (
                <li key={c} className="flex items-start gap-3 text-[#4E5750]/85">
                  <span className="shrink-0 w-5 h-5 rounded-full border border-[#B79A68] flex items-center justify-center mt-0.5">
                    <Check size={11} className="text-[#7D6A42]" />
                  </span>
                  {c}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-9 flex gap-3 flex-wrap">
            <Button to="/contact">Book A Consult</Button>
            <Button to="/smile-gallery" variant="outline">See Smile Gallery</Button>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default MeetDoctor;
